import { CardConsultDataResponseDTO } from "@repo/core/services/entities/Card";
import { Control } from "react-hook-form";

export interface IdentityTypeInputProps {
  selectedInputType: IdentityInputTypeEnum;
  onChangeInputType: (inputType: string) => void;
  onSelectProduct: (productInfo: CardConsultDataResponseDTO) => void;
  onSubmitCardNumber?: () => void;
  showCardExpiryInput?: boolean;
  showProductsLoading?: boolean;
  shouldFetchOnCardSubmit?: boolean;
  onFetchProducts?: () => void;
  onFetchProductsFinish?: (productInfo?: CardConsultDataResponseDTO) => void;
  onFetchCard?: () => void;
  onFetchCardFinish?: (productInfo?: CardConsultDataResponseDTO) => void;
  onChangeCard?: (value: string) => void;
  onChangeCPF?: (value: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any, any>;
}

export enum IdentityInputTypeEnum {
  CPF = "cpf",
  CARD = "card"
}

export interface CardData {
  expiryDate: string;
  cardLng: number;
  product: string;
}
